export const changeLangAction = (lang) => {
    return {
        type: 'CHANGE_LANG',
        lang
    }
}